import community from "./community.png";
import { LinkButton } from "../components/Buttons.js";

const Community = () => {
  return (
    <div className="container" id="community">
      <div className="row">
        <div
          className="col-12 col-md-6 d-flex align-items-center pre"
          data-aos="fade-left"
          data-aos-duration="1200"
          style={{ marginBottom: "30px" }}
        >
          <div>
            <h3>Our beNFTs</h3>
            <h2>Join our Community</h2>
            <p>
              We grant our Lion Travelers holders access to an elite business
              club with one-in-a-time advantages and previews on special
              projects.
              <br />
              Join our Discord channel and don’t miss the whitelist
              access!&nbsp;
              <br />
            </p>
            <LinkButton
              classname="btn twitter-button"
              target="blank"
              link="https://twitter.com/LionTravelers"
              text="Twitter"
            />
            <LinkButton
              classname="btn discord-button"
              href="https://discord.com/invite/gddBqAKZyU"
              target="blank"
              text="Discord"
            />
          </div>
        </div>
        <div
          className="col-12 col-md-6 d-md-flex d-lg-flex justify-content-md-center align-items-md-center order-md-first justify-content-xl-center align-items-xl-center pre"
          data-aos="fade-right"
          data-aos-duration="1200"
        >
          <div>
            <img
              src={community}
              loading="lazy"
              alt="Lion Travelers NFT community"
            />
          </div>
        </div>
      </div>
      <form className="whitelist">
        <div className="row">
          <div className="col-12 col-lg-4">
            <h2>Private Sale Whitelist</h2>
          </div>
          <div className="col d-lg-flex justify-content-lg-center align-items-lg-center">
            <h3 style={{ textAlign: "center" }}>Coming soon!</h3>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Community;
